import { createContext, forwardRef, useContext, useRef, useState } from "react";

import FnrCard from "UI/FnrCard/FnrCard";

import useIsWiderThan from "Utilities/Hooks/useIsWiderThan";

const TierPricingContext = createContext();
const useTierPricingContext = () => useContext(TierPricingContext);

const Container = forwardRef(({ showCard, children }, ref) => {
  if (showCard)
    return (
      <FnrCard ref={ref} style={{ padding: 0, borderRadius: 16 }}>
        {children}
      </FnrCard>
    );
  else return <div ref={ref}>{children}</div>;
});

const TierPricingProvider = ({
  children,
  tierData,
  setTierData = () => {},
  setTierDataValid = () => {},
  showCard = true,
  suggestedDonation,
  entity,
  disabled,
  preventTierAnimation,
}) => {
  const containerRef = useRef();
  const isFullWidth = useIsWiderThan(containerRef, { px: 365 });

  const [errorMessage, setErrorMessage] = useState(false);

  return (
    <TierPricingContext.Provider
      value={{
        tierData: tierData?.map(({ ID, id = ID, ...rest }) => ({
          id,
          ...rest,
        })),
        setTierData,
        setTierDataValid,
        isFullWidth,
        suggestedDonation,
        entity,
        disabled,
        preventTierAnimation,
        errorMessage,
        setErrorMessage,
      }}
    >
      <Container showCard={showCard} ref={containerRef}>
        {children}
      </Container>
    </TierPricingContext.Provider>
  );
};

export { useTierPricingContext };
export default TierPricingProvider;
